import Layout from '@/layout/index';
import Detail from '@/views/LiveModule/detail';
import CustomerTab from '@/views/LiveModule/CustomerTabView';

const router = [
  {
    path: '/videoTailoring/:str(\\d+)',
    meta: { auth: true, title: '', name: 'videoTailoring' },
    component: () => import('@/views/LiveModule/PlayBack/videoTailoring'),
    hidden: true
  },
  {
    path: '/clientLiveEdit',
    meta: { auth: false, title: '', name: 'clientLiveEdit' },
    component: () => import('@/views/LiveModule/edit'),
    hidden: true
  },
  {
    path: '/previewChapter/:str(\\d+)',
    component: () => import('@/views/LiveModule/PlayBack/previewChapter'),
    meta: { auth: true, title: '回放-章节预览', name: 'previewChapter', activeMenu: '/live/list' },
    hidden: true
  },
  {
    path: '/chapter/:str(\\d+)',
    component: () => import('@/views/LiveModule/PlayBack/chapter'),
    meta: { auth: true, title: '章节打点', name: 'chapter', activeMenu: '/live/list' },
    hidden: true
  },
  {
    path: '/recordchapter/:str(\\d+)',
    component: () => import('@/views/LiveModule/PlayBack/chapter'),
    meta: { auth: true, title: '章节打点', name: 'recordchapter', activeMenu: '/live/list' },
    hidden: true
  },
  // 直播活动路由
  {
    path: '/live',
    component: Layout,
    redirect: '/live/list',
    meta: { auth: true, title: '直播管理', icon: 'saasicon_lives_img', level: 1, name: 'liveMgr' },
    children: [
      {
        path: 'list',
        component: () => import('@/views/LiveModule/list'),
        meta: { auth: true, title: '直播列表', level: 2, name: 'liveList' }
      },
      {
        path: 'edit',
        component: () => import('@/views/LiveModule/edit'),
        meta: {
          auth: true,
          title: '创建直播',
          level: 2,
          name: 'liveCreate',
          webinarType: 'live',
          activeMenu: '/live/edit'
        }
      },
      {
        path: 'edit/:id',
        component: () => import('@/views/LiveModule/edit'),
        meta: {
          auth: true,
          title: '编辑直播',
          level: 2,
          name: 'liveEdit',
          webinarType: 'live',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'vodEdit/:id',
        component: () => import('@/views/LiveModule/edit'),
        meta: {
          auth: true,
          title: '编辑点播',
          name: 'vodEdit',
          webinarType: 'vod',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'vodEdit',
        component: () => import('@/views/LiveModule/edit'),
        meta: {
          auth: true,
          title: '创建点播',
          name: 'vodCreate',
          webinarType: 'vod',
          activeMenu: '/live/vodEdit',
          auth_key: 'ui.upload_video_as_demand'
        }
      },
      {
        path: 'timeEdit',
        component: () => import('@/views/LiveModule/edit'),
        meta: {
          auth: true,
          title: '定时直播',
          level: 2,
          name: 'liveTimeCreate',
          webinarType: 'time',
          activeMenu: '/live/timeEdit',
          auth_key: 'webinar.timing'
        }
      },
      {
        path: 'timeEdit/:id',
        component: () => import('@/views/LiveModule/edit'),
        meta: {
          auth: true,
          title: '编辑定时直播',
          level: 2,
          name: 'liveTimeEdit',
          webinarType: 'time',
          activeMenu: '/live/timeEdit'
        },
        hidden: true
      },
      {
        path: 'detail/:str(\\d+)',
        component: Detail,
        meta: { auth: true, title: '直播详情', name: 'liveDetail', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'chooseWay/:str/:role?',
        component: () => import('@/views/LiveModule/chooseWay'),
        meta: {
          auth: true,
          title: '选择发起方式',
          name: 'chooseWay',
          level: 3,
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'signup/:str(\\d+)',
        component: () => import('@/views/LiveModule/signUp/main'),
        meta: { auth: true, title: '报名表单', name: 'signup', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'viewerRules/:str(\\d+)',
        component: () => import('@/views/LiveModule/viewerRules'),
        meta: { auth: true, title: '观看限制', name: 'viewerRules', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'roleInvitation/:str(\\d+)',
        component: () => import('@/views/LiveModule/roleInvitation'),
        meta: { auth: true, title: '角色权限', name: 'roleInvitation', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'planFunction/:str(\\d+)',
        component: () => import('@/views/LiveModule/planFunction'),
        meta: { auth: true, title: '功能配置', name: 'planFunction', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'virtual/:str(\\d+)',
        component: () => import('@/views/LiveModule/virtual'),
        meta: { auth: true, title: '虚拟人数', name: 'virtual', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'warm/:str(\\d+)',
        component: () => import('@/views/LiveModule/warm'),
        meta: { auth: true, title: '暖场视频', name: 'warm', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'embedCard/:str(\\d+)',
        component: () => import('@/views/LiveModule/embedCard'),
        meta: { auth: true, title: '嵌入方式', name: 'embedCard', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'langCard/:str(\\d+)',
        component: () => import('@/views/LiveModule/langCard'),
        meta: { auth: true, title: '多语言', name: 'langCard', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'compliance/:str(\\d+)',
        component: () => import('@/views/LiveModule/Compliance'),
        meta: {
          auth: true,
          title: '合规风险设置',
          name: 'compliance',
          activeMenu: '/live/list',
          appCls: 'std-app'
        },
        hidden: true
      },
      {
        path: 'pushStream/:str(\\d+)',
        component: () => import('@/views/LiveModule/pushStream'),
        meta: { auth: true, title: '推流地址', name: 'pushStream', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'msgNotification/:str(\\d+)',
        component: () => import('@/views/LiveModule/msgNotification'),
        meta: { auth: true, title: '开播提醒', name: 'msgNotification', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'pushCard/:str(\\d+)',
        component: () => import('@/views/LiveModule/PushCard/main'),
        meta: { auth: true, title: '推屏卡片', name: 'pushCard', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'addPushCard',
        component: () => import('@/views/LiveModule/PushCard/components/addCard'),
        meta: { auth: true, title: '创建', name: 'addPushCard', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'clickPushCard',
        component: () => import('@/views/LiveModule/PushCard/components/clickCard'),
        meta: { auth: true, title: '点击人数', name: 'clickPushCard', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'livingSet/:str(\\d+)',
        component: () => import('@/views/LiveModule/Brands/livingSetting'),
        meta: {
          auth: true,
          title: '直播间设计器',
          name: 'livingSetting',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'safeScreenSet/:str(\\d+)',
        component: () => import('@/views/LiveModule/Brands/safeScreenSet'),
        meta: { auth: true, title: '防录屏设置', name: 'safeScreenSet', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'playerSet/:str(\\d+)',
        component: () => import('@/views/LiveModule/Brands/playerSet'),
        meta: { auth: true, title: '播放器设置', name: 'playerSet', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'invCard/:str(\\d+)',
        component: () => import('@/views/LiveModule/Invite/InvitationCard/invitationCard.vue'),
        meta: { auth: true, title: '邀约海报', name: 'invCard', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'advertCard/:str(\\d+)',
        component: () => import('@/views/LiveModule/Brands/advertisementCard'),
        meta: { auth: true, title: '广告', name: 'advertCard', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'officialCard/:str(\\d+)',
        component: () => import('@/views/LiveModule/Brands/officialCard'),
        meta: { auth: true, title: '公众号展示', name: 'officialCard', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'officeSet/:str(\\d+)',
        component: () => import('@/views/LiveModule/Brands/officialCard'),
        meta: { auth: true, title: '公众号', name: 'officeSet', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'posterCard/:str(\\d+)',
        component: () => import('@/views/LiveModule/Brands/posterCard'),
        meta: { auth: true, title: '开屏海报', name: 'posterSet', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'shareSetting/:str(\\d+)',
        component: () => import('@/views/LiveModule/Invite/shareSetting'),
        meta: { auth: true, title: '微信分享', name: 'shareSet', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'word/:str(\\d+)',
        component: () => import('@/views/MaterialModule/word'),
        meta: { auth: true, title: '文档', name: 'word', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'videoSet/:str(\\d+)',
        component: () => import('@/views/LiveModule/MaterialSet/videoSet'),
        meta: { auth: true, title: '插播文件', name: 'videoSet', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'signInSet/:str(\\d+)',
        component: () => import('@/views/LiveModule/MaterialSet/signInSet'),
        meta: { title: '签到', name: 'signInSet' },
        hidden: true
      },
      {
        path: 'winnerList/:str(\\d+)',
        component: () => import('@/views/LiveModule/MaterialSet/winnerList'),
        meta: { auth: true, title: '中奖用户', name: 'winnerList', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'prizeList/:str(\\d+)',
        component: () => import('@/views/LiveModule/MaterialSet/prizeList'),
        meta: { auth: true, title: '在线抽奖', name: 'prizeList', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'prizeSet/:str(\\d+)',
        component: () => import('@/views/LiveModule/MaterialSet/prizeSet'),
        meta: { auth: true, title: '在线抽奖', name: 'prizeCreat', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'question/:str(\\d+)',
        component: () => import('@/views/LiveModule/MaterialSet/question'),
        meta: { auth: true, title: '问卷', name: 'question', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'addQuestion',
        component: () => import('@/views/LiveModule/MaterialSet/components/addQuestion'),
        meta: { auth: true, title: '创建问卷', name: 'addQuestion', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'exam/:str(\\d+)',
        component: () => import('@/views/LiveModule/Exam/main'),
        meta: { auth: true, title: '快问快答', name: 'exam', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'addExam',
        component: () => import('@/views/LiveModule/Exam/components/addExam'),
        meta: { auth: true, title: '创建', name: 'addExam', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'productSet/:str(\\d+)',
        component: () => import('@/views/MaterialModule/Products/index.vue'),
        meta: { auth: true, title: '商品', name: 'productSet', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'couponData/:str(\\d+)',
        component: () => import('@/views/MaterialModule/Products/viewCoupon.vue'),
        meta: { auth: true, title: '优惠券数据', name: 'couponData', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'gift/:str(\\d+)',
        component: () => import('@/views/LiveModule/MaterialSet/giftSet'),
        meta: { auth: true, title: '礼物', name: 'gift', activeMenu: '/live/list' },
        hidden: true
      },
      {
        // 列表
        path: 'InteractReward/:str(\\d+)',
        component: () => import('@/views/LiveModule/InteractReward/index.vue'),
        meta: { auth: true, title: '互动有礼', name: 'InteractReward', activeMenu: '/live/list' },
        hidden: true
      },
      {
        // 创建、编辑、复制共用
        path: 'InteractiveRewardSetting/:str(\\d+)',
        component: () => import('@/views/LiveModule/InteractReward/setting/index.vue'),
        meta: {
          auth: true,
          title: '互动有礼',
          name: 'InteractiveRewardSetting',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        // 领奖用户列表
        path: 'InteractiveRewardUserList/:str(\\d+)',
        component: () => import('@/views/LiveModule/InteractReward/UserList.vue'),
        meta: {
          auth: true,
          title: '互动有礼',
          name: 'InteractiveRewardUserList',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        // 列表
        path: 'WatchReward/:str(\\d+)',
        component: () => import('@/views/LiveModule/WatchReward/index.vue'),
        meta: { auth: true, title: '观看有礼', name: 'WatchReward', activeMenu: '/live/list' },
        hidden: true
      },
      {
        // 创建、编辑、复制共用
        path: 'WatchRewardSetting/:str(\\d+)',
        component: () => import('@/views/LiveModule/WatchReward/setting/index.vue'),
        meta: {
          auth: true,
          title: '观看有礼',
          name: 'WatchRewardSetting',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        // 领奖用户列表
        path: 'WatchRewardWinnerList/:str(\\d+)',
        component: () => import('@/views/LiveModule/WatchReward/WinnerList.vue'),
        meta: {
          auth: true,
          title: '观看有礼',
          name: 'WatchRewardWinnerList',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        // 列表
        path: 'CashPacket/:id',
        component: () => import('@/views/LiveModule/CashPacket/list.vue'),
        meta: { auth: true, title: '现金红包', name: 'CashPacketList', activeMenu: '/live/list' },
        hidden: true
      },
      {
        // 创建/编辑
        path: 'CashPacket/edit/:id',
        component: () => import('@/views/LiveModule/CashPacket/edit.vue'),
        meta: { auth: true, title: '现金红包', name: 'CashPacketEdit', activeMenu: '/live/list' },
        hidden: true
      },
      {
        //
        path: 'CashPacket/record/:id/:redpacket_id',
        component: () => import('@/views/LiveModule/CashPacket/receiptDetails.vue'),
        meta: { auth: true, title: '领取用户', name: 'receiptDetails', activeMenu: '/live/list' },
        hidden: true
      },
      {
        // 列表
        path: 'MallRewards/:id',
        component: () => import('@/views/LiveModule/MallRewards/list.vue'),
        meta: {
          auth: true,
          title: '商城奖励',
          name: 'MallRewardsList',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        // 创建/编辑
        path: 'MallRewards/edit/:id',
        component: () => import('@/views/LiveModule/MallRewards/edit.vue'),
        meta: { auth: true, title: '商城奖励', name: 'MallRewardsEdit', activeMenu: '/live/list' },
        hidden: true
      },
      {
        //
        path: 'MallRewards/record/:id/:reward_id',
        component: () => import('@/views/LiveModule/MallRewards/receiptDetails.vue'),
        meta: {
          auth: true,
          title: '领取用户',
          name: 'mallReceiptDetails',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'playback/:str(\\d+)',
        component: () => import('@/views/LiveModule/PlayBack/list'),
        meta: { auth: true, title: '回放管理', name: 'playback', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'playback/:str(\\d+)/group/:switch_id(\\d+)',
        component: () => import('@/views/LiveModule/PlayBack/groupList'),
        meta: {
          auth: true,
          title: '小组视频',
          name: 'playbackGroupList',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'recordplayback/:str(\\d+)',
        component: () => import('@/views/LiveModule/PlayBack/list'),
        meta: { auth: true, title: '点播管理', name: 'recordplayback', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'publishplayback/:str(\\d+)',
        component: () => import('@/views/LiveModule/PlayBack/list'),
        meta: { auth: true, title: '视频管理', name: 'publishplayback', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'vodreset/:str(\\d+)',
        component: () => import('@/views/LiveModule/PlayBack/vodreset'),
        meta: { auth: true, title: '课件重制', name: 'vodreset', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'reportsData/:str(\\d+)',
        component: () => import('@/views/LiveModule/Data/reportsData'),
        meta: { auth: true, title: '数据报告', name: 'reportsData', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'interactionData/:str(\\d+)',
        component: () => import('@/views/LiveModule/Data/interactData'),
        meta: { auth: true, title: '互动统计', name: 'interactionData', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'userData/:str(\\d+)',
        component: () => import('@/views/LiveModule/Data/userData'),
        meta: { auth: true, title: '用户统计', name: 'userData', activeMenu: '/live/list' },
        hidden: true
      },
      {
        path: 'interactionDetail',
        component: () => import('@/views/LiveModule/Data/interactDetail'),
        meta: {
          auth: true,
          title: '查看数据',
          name: 'interactionDetail',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'interactionDetail/invitedDataInfo',
        component: () => import('@/views/LiveModule/Data/invitedDataInfo'),
        meta: {
          auth: true,
          title: '邀请明细',
          name: 'invitedDataInfo',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'lookSingleQuestion/:str(\\d+)',
        component: () => import('@/views/LiveModule/Data/lookSingleQuestion'),
        meta: {
          auth: true,
          title: '查看问卷详情',
          name: 'lookSingleQuestion',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'lookSingleExam/:str(\\d+)',
        component: () => import('@/views/LiveModule/Data/lookSingleExam'),
        meta: {
          auth: true,
          title: '查看快问快答明细',
          name: 'lookSingleExam',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'channel/:str(\\d+)',
        component: () => import('@/views/LiveModule/Invite/channel'),
        meta: {
          auth: true,
          title: '推广渠道',
          name: 'channel',
          activeMenu: '/live/list',
          auth_key: 'watch.channel'
        },
        hidden: true
      },
      {
        path: 'AI/chat/list/:id(\\d+)',
        component: () => import('@/views/AIModule/chat/list'),
        meta: {
          auth: true,
          title: 'AI聊天',
          name: 'AIChatListLive',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'AI/chat/create',
        component: () => import('@/views/AIModule/chat/edit'),
        meta: {
          auth: true,
          title: '创建',
          name: 'AIChatCreateLive',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'AI/chat/edit/:id(\\d+)',
        component: () => import('@/views/AIModule/chat/edit'),
        meta: {
          auth: true,
          title: '编辑',
          name: 'AIChatEditLive',
          activeMenu: '/live/list'
        },
        hidden: true
      },
      {
        path: 'embedPage/:str(\\d+)/:type/:index',
        component: () => import('@/views/LiveModule/embedPage'),
        meta: { auth: true, title: '嵌入页', name: 'embedPage', activeMenu: '/live/list' },
        hidden: true
      }
    ]
  },
  // 专题路由
  {
    path: '/special',
    component: Layout,
    redirect: '/special/list',
    meta: {
      auth: true,
      title: '专题管理',
      name: 'specialList',
      icon: 'saasicon_projects_img',
      level: 1,
      auth_key: 'subject_manager'
    },
    children: [
      {
        path: 'list',
        component: () => import('@/views/SpecialModule/list'),
        meta: {
          auth: true,
          title: '专题管理',
          name: 'specialList',
          level: 2,
          activeMenu: '/special/list',
          auth_key: 'subject_manager'
        }
      },
      {
        path: 'edit',
        component: () => import('@/views/SpecialModule/edit'),
        meta: {
          auth: true,
          title: '创建专题',
          name: 'subjectEdit',
          level: 2,
          activeMenu: '/special/edit',
          auth_key: 'subject_manager'
        },
        hidden: true
      },
      {
        path: 'edit/:id',
        component: () => import('@/views/SpecialModule/edit'),
        meta: {
          auth: true,
          title: '编辑专题',
          name: 'subjectEdit',
          level: 2,
          activeMenu: '/special/list',
          auth_key: 'subject_manager'
        },
        hidden: true
      },
      {
        path: 'data/:id',
        component: () => import('@/views/SpecialModule/data'),
        meta: {
          auth: true,
          title: '查看数据', // 导出数据
          name: 'subjectData',
          level: 2,
          activeMenu: '/special/list',
          auth_key: 'subject_manager'
        },
        hidden: true
      },
      {
        path: 'viewer/:id',
        component: () => import('@/views/SpecialModule/viewer'),
        meta: {
          auth: true,
          title: '观看限制',
          name: 'subjectViewer',
          level: 2,
          activeMenu: '/special/list',
          auth_key: 'subject_manager'
        },
        hidden: true
      },
      {
        path: 'details/:id',
        component: () => import('@/views/SpecialModule/details'),
        meta: {
          auth: true,
          title: '专题详情',
          name: 'subjectDetails',
          level: 2,
          activeMenu: '/special/list',
          auth_key: 'subject_manager'
        },
        hidden: true
      }
    ]
  },
  {
    path: '/chooseWay/:str/:role?',
    component: () => import('@/views/LiveModule/chooseWay'),
    meta: { auth: true, title: '选择发起方式', name: 'chooseWay' },
    hidden: true
  }
];
export default router;
